
<!-- <p>
  <mat-toolbar color="primary">
    <span >Admin : User Management : Assign Roles to Power User</span>
  </mat-toolbar>
</p>

<form  [formGroup]="assignRoleToPowerUser">
    <mat-form-field class="power_user_field" appearance="outline">
        <mat-label >Power User # </mat-label>
        <input matInput  disabled formControlName="PowerUserId">
      </mat-form-field>

      <mat-form-field appearance="outline" class="status_field">
        <mat-label>User Status </mat-label>
        <input matInput disabled formControlName="status">
      </mat-form-field>

      <button mat-raised-button class = "update_status_button" color="primary" (click) = "OnClickChangeStatus()">Change Status</button><br>
    
      <mat-form-field class="name_width" appearance="outline">
        <mat-label>Name </mat-label>
        <input matInput disabled formControlName="name">
      </mat-form-field><br>

      <mat-form-field appearance="outline" class= "select_role">
        <mat-label>Select Role <span style = "color: red">*</span></mat-label>
              <mat-select  (selectionChange)="onRoleChange($event.value)">
          <mat-option *ngFor="let role of selectRole"  value="{{role.Code}}">{{role.Name}}</mat-option>
        </mat-select>
      </mat-form-field> <br>

      <mat-form-field class="other_width" appearance="outline">
        <mat-label>Start Date</mat-label>
        <input matInput [matDatepicker]="startDatePicker" required formControlName="startDate">
        <mat-datepicker-toggle matSuffix [for]="startDatePicker"></mat-datepicker-toggle>
        <mat-datepicker #startDatePicker></mat-datepicker>
      </mat-form-field> <br>

      <mat-form-field class="other_width" appearance="outline">
        <mat-label>End Date</mat-label>
        <input matInput [matDatepicker]="endDatePicker"  formControlName="endDate">
        <mat-datepicker-toggle matSuffix [for]="endDatePicker"></mat-datepicker-toggle>
        <mat-datepicker #endDatePicker></mat-datepicker>
      </mat-form-field>

      <--------- need to change the css over here ----------->

      <!-- <div class = " subject-area"> <br>

          <mat-label><span class = "subject-header">Subject</span></mat-label> 


          <button mat-raised-button color="primary" class = "add_subject_field_button" (click)="addvalue()" >Add Subject</button> <br> <br>

          <mat-form-field appearance="outline" class = "select_subject" >
            <mat-label>Select Primary Subject <span style = "color: red">*</span></mat-label>
            <mat-select formControlName="primarySubject" (selectionChange)="onPrimarySubjectChange($event.value)">
              <mat-option *ngFor = "let subject of subjectType"  value="{{subject.Code+' '+subject.Name}}">{{subject.Name}}</mat-option>
            </mat-select>
          </mat-form-field> 
          
          <div  *ngFor="let value of values; let i = index">

            <mat-form-field appearance="outline" class = "subject_input" >
              <mat-label>Select Additional Subject </mat-label>
              <mat-select formControlName="additionalSubject" (selectionChange)="onAdditionalSubjectChange($event.value)">
                <mat-option *ngFor = "let subject of subjectType"  value="{{subject.Code+' '+subject.Name}}">{{subject.Name}}</mat-option>
              </mat-select>
            </mat-form-field> 
            
              <button mat-raised-button (click)="removevalue(i)" class = "remove_button">Remove</button>
            
        </div>


    </div>
    <br>


    <mat-form-field class="example-full-width" appearance="outline">
      <mat-label>Comments/Notes</mat-label>
      <textarea matInput formControlName="comment"></textarea>
    </mat-form-field> <br>
    
      
      <button mat-raised-button class = "mat-button" color="primary" [disabled] = "assignRoleToPowerUser.invalid" (click) = "OnClickSubmitRole()">Save</button>

      <button mat-raised-button class = "mat-button" type = "reset" color="primary" >Clear</button>

      <button mat-raised-button class = "mat-button"  (click) = "OnClickCancelButton()" >Cancel</button>
      <br> <br>
    
    </form>  -->
    <div class="row">


    <div class="col-12" style="height:80vh !important; overflow: auto;">
      
        <div class="row pt-1">
          <div class="col-12">
<div class="row">


        <div class="col-8">

          <form [formGroup]="assignRoleToPowerUser">
            <div class="row pt-1">
              <div class="col-4 text-right  pt-1 pl-1 pr-0">
                <div class="d-flex flex-row-reverse">
                  <!-- <div class="p-0 label-red">*</div>          -->
                  <div class="p-0">Power User #</div>                 
                  </div>
               
              </div>
              <div class="col-8 pt-1 px-1">
                <input type="text" [attr.disabled]="true" readonly="readonly" formControlName="PowerUserId" class="form-control form-control-sm input-txt"/>
              </div>
            </div>
            <div class="row pt-1">
              <div class="col-4 text-right  pt-1 pl-1 pr-0">
                <div class="d-flex flex-row-reverse">
                  <!-- <div class="p-0 label-red">*</div>          -->
                  <div class="p-0">Name</div>                 
                  </div>
               
              </div>
              <div class="col-8 pt-1 px-1">
                <input type="text"  [attr.disabled]="true" readonly="readonly" formControlName="name" class="form-control form-control-sm input-txt"/>
              </div>
            </div>
            <div class="row pt-1">
              <div class="col-4 text-right  pt-1 pl-1 pr-0">
                <div class="d-flex flex-row-reverse">
                  <!-- <div class="p-0 label-red">*</div>          -->
                  <div class="p-0">Select Role</div>                 
                  </div>
               
              </div>
              <div class="col-8 pt-1 px-1">
                <select  class="form-control form-control-sm input-txt" (change)="onRoleChange($event)">
                     
                  <option class="border-bottom" *ngFor="let role of selectRole"  value="{{role.Code}}">{{role.Name}}</option>
                </select>
              </div>
            </div>
            <div class="row pt-1">
              <div class="col-4 text-right  pt-1 pl-1 pr-0">
                <div class="d-flex flex-row-reverse">
                  <div class="p-0 label-red">*</div>         
                  <div class="p-0">Start date</div>                 
                  </div>
               
              </div>
              <div class="col-8 pt-1 px-1">
                <input type="text" required formControlName="startDate" [owlDateTime]="dt1" [owlDateTimeTrigger]="dt1"
                class="form-control form-control-sm input-txt" (ngModelChange)="compareStartDates()">
              <owl-date-time [pickerType]="'calendar'" #dt1></owl-date-time>
              </div>
              <div class="col-4"></div>
           <div class="col-8 pt-1 px-1"><label  class="Valid1"  *ngIf="error1.isError">{{error1.errorMessage}}</label>
      </div>
            </div>
            <div class="row pt-1">
              <div class="col-4 text-right  pt-1 pl-1 pr-0">
                <div class="d-flex flex-row-reverse">
                  <!-- <div class="p-0 label-red">*</div>          -->
                  <div class="p-0">End date</div>                 
                  </div>
               
              </div>
              <div class="col-8 pt-1 px-1">
                <input type="text"   formControlName="endDate" [owlDateTime]="dt2" [owlDateTimeTrigger]="dt2"
                class="form-control form-control-sm input-txt" (ngModelChange)="compareEndDates()">
              <owl-date-time [pickerType]="'calendar'" #dt2></owl-date-time>
              </div>
              <div class="col-4"></div>
              <div class="col-8 pt-1 px-1"><label  class="Valid1" *ngIf="error.isError">{{ error.errorMessage }}</label></div>
            </div>
            <div class="row pt-1">
              <div class="col-4 text-right  pt-1 pl-1 pr-0">
                <div class="d-flex flex-row-reverse">
                  <!-- <div class="p-0 label-red">*</div>          -->
                  <div class="p-0">Subject</div>                 
                  </div>
               
              </div>
              <div class="col-8 pt-1 px-1">
                <div class="d-flex">
                  <div class="px-0">
                    <button type="button"  class="btn btn-sm bl-btn" (click)="addvalue()">Add Subject</button>
                  </div>
                </div>
              </div>
            </div>
            <div class="row pt-1">
              <div class="col-4 text-right  pt-1 pl-1 pr-0">
                <div class="d-flex flex-row-reverse">
                  <div class="p-0 label-red">*</div>         
                  <div class="p-0">Select Primary Subject</div>                 
                  </div>
               
              </div>
              <div class="col-8 pt-1 px-1">
                <select  class="form-control form-control-sm input-txt" formControlName="primarySubject" (click)="getvalue($event)" (change)="onPrimarySubjectChange($event)">
                     
                  <option class="border-bottom"  *ngFor = "let subject of subjectType"  [value]="subject.Code" >{{subject.Name}}</option>
                </select>
              </div>
            </div>
          </form>
            <div  *ngFor="let value of values;let i = index">
            <div class="row pt-1">
              <div class="col-4 text-right  pt-1 pl-1 pr-0">
                <div class="d-flex flex-row-reverse">
                  <!-- <div class="p-0 label-red">*</div>          -->
                  <div class="p-0">Select Additional Subject</div>                 
                  </div>
               
              </div>
              <div class="col-8 pt-1 px-1">
                <div class="d-flex">
                  <div class="px-0">
                    <!-- | callback: filterUser -->
                    <select  class="form-control form-control-sm input-txt"  [(ngModel)]="value.Code" (click)="getvalue($event)" (change)="onAdditionalSubjectChange($event,i)">
                     
                      <option class="border-bottom" *ngFor = "let subject of subjectType" [value]="subject.Code">{{subject.Name}}</option>
                    </select>
                  </div>
                  <div class="px-1">
                    <button type="button"  class="btn btn-sm bg-light border" (click)="removevalue(i)">Remove</button>
                  </div>
                 
                 
                 
                  
                </div>
              </div>
            </div>
            
            </div>
            <form [formGroup]="assignRoleToPowerUser">
            <div class="row pt-1">
              <div class="col-4 text-right  pt-1 pl-1 pr-0">
                <div class="d-flex flex-row-reverse">
                  <!-- <div class="p-0 label-red">*</div>          -->
                  <div class="p-0">Comments/Notes</div>                 
                  </div>
               
              </div>
              <div class="col-8 pt-1 px-1">
                <textarea  maxlength="4000" formControlName="comment" class="form-control input-txt1"
                ></textarea>
              </div>
            </div>
            
            
           
           
           <div class="row pt-3 pb-1">
            <div class="col-4">
             
             
            </div>
            <div class="col-8 pt-1 px-1">
              <div class="d-flex">
                <div class="px-1">
                 
                <button type="submit"  class="btn btn-sm bl-btn"  [disabled] = "assignRoleToPowerUser.invalid||error.isError||error1.isError" (click) = "OnClickSubmitRole()">Save</button>
                </div>
                <!-- <div class="px-1">
                  <button type="reset"   class="btn btn-sm bg-light border">Clear</button>
                  
                </div> -->
                <div class="px-1">
                  <button type="button"   class="btn btn-sm bg-light border" (click) = "OnClickCancelButton()">Cancel</button>
                </div>
               
                
              </div>
            </div>
          </div>
            </form>
        
          
              </div>
              
             
     
              
             
           
   
          <div class="col-4">
            <form [formGroup]="assignRoleToPowerUser">
            <div class="row pt-1">
              <div class="col-4 text-right  pt-1 pl-1 pr-0">
                <div class="d-flex flex-row-reverse">
                  <!-- <div class="p-0 label-red">*</div>          -->
                  <div class="p-0">Role Status</div>                 
                  </div>
               
              </div>
              <div class="col-8 pt-1 px-1">
                <input type="text" [attr.disabled]="true" readonly="readonly" formControlName="status" class="form-control form-control-sm input-txt11"/>
              </div>
            </div>
            <div class="row pt-2">
              <div class="col-4">
                
               
              </div>
              <!-- <div class="col-8 pt-1 px-1">
                <div class="d-flex">
                  <div class="px-1">
                   
                  <button type="submit"  class="btn btn-sm bg-light border">Change Status</button>
                  </div>
                 
                 
                  
                </div>
              </div> -->
            </div>
            </form>
           
          </div>
        </div>
       
        </div>
          </div>
        
    </div>
  </div>
  <div class="modal fade  show modal-dialog-centered"style="padding-right: 4px;display: block;background-color: #00000075;" *ngIf="Cancelalertpopup">
    <div class="modal-dialog modal-dialog-alert1 modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header border Page-Header p-1 py-0">
          <h6 class="HeadContent" id="QuestionTemplatetitle">Alert</h6>
          <button type="button" class="close" 
            style="padding-right: 20px;font-size: 30px;outline: 0;" (click)="AlertCancelpopup()">
            <span aria-hidden="true">&times;</span></button>
        </div>
       
        <div class="modal-body px-3 py-0">
          <div class="row py-2 mx-2 pt-3">
            <div class="col-12">
              <label>Do you want to Discard or Continue Editing ?</label>
            </div>
          </div>
          <div class="row p-1">
            <div class="col-12">
              <div class="d-flex justify-content-center">
                <div class="px-1">
                  <button type="button"  class="btn btn-sm bg-light border" (click)="DiscardChanges()" >Discard Changes</button>
                </div>
                <div class="px-1">
                  <button type="button"  class="btn btn-sm bl-btn" (click)="AlertCancelpopup()" >Continue Editing</button>
                </div>
                
              </div>
            </div>
          </div>
        
        </div>
      </div>
    </div>
  </div>
  <div class="modal fade  show modal-dialog-centered"style="padding-right: 4px;display: block;background-color: #00000075;" *ngIf="subjectalertflag">
    <div class="modal-dialog modal-dialog-alert2 modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header border Page-Header p-1 py-0">
          <h6 class="HeadContent" id="QuestionTemplatetitle">Alert</h6>
          <!-- <button type="button" class="close" 
            style="padding-right: 20px;font-size: 30px;outline: 0;">
            <span aria-hidden="true">&times;</span></button> -->
        </div>
       
        <div class="modal-body px-3 py-0">
          <div class="row py-2 mx-2 pt-3">
            <div class="col-12">
              <label>Subject Already Selected!</label>
            </div>
          </div>
          <div class="row p-1">
            <div class="col-12">
              <div class="d-flex justify-content-center">
                <div class="px-1">
                  <button type="button"  class="btn btn-sm bg-light border" (click)="clearform()" >OK</button>
                </div>
                
              </div>
            </div>
          </div>
        
        </div>
      </div>
    </div>
  </div>